<template>
  <div class="header">
    <div class="container">
      <div class="inner">
        <HeaderSteps :screen-width="screenWidth" />
      </div>
      <!-- The title sits on the wrapper because .share-btn.disabled has
           pointer-events: none, so a title on the button itself never shows. -->
      <div :title="shareDisabledReason">
        <div
          class="share-btn"
          :class="{ disabled: !canShareBuild }"
          @click="openSharePopup"
        >
          <span class="share-btn-label">Deel je samenstelling</span>
          <div class="share-icon">
            <ShareIcon />
          </div>
        </div>

        <SharePopup :open="open" @close="open = false" />
      </div>

      <div class="next" v-if="showNextButton || currentStep === 3">
        <ButtonNext
          v-if="showNextButton"
          :disabled="!canGoToNextStep"
          @nextStep="onNextStep"
        />
        <SwitchChangeAmount v-else-if="currentStep === 3" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import ButtonNext from '../utilities/ButtonNext';
import SwitchChangeAmount from './SwitchChangeAmount';
import HeaderSteps from './HeaderSteps';
import SharePopup from '@/components/popups/SharePopup.vue';
import ShareIcon from '@/components/icons/ShareIcon.vue';

export default {
  name: 'AppHeader',

  components: {
    ShareIcon,
    SharePopup,
    HeaderSteps,
    SwitchChangeAmount,
    ButtonNext,
  },

  data() {
    return {
      initialScroll: null,
      screenWidth: innerWidth,
      open: false,
    };
  },

  computed: {
    ...mapState('step', ['currentStep']),
    ...mapGetters({
      products: 'build/getProducts',
      rooms: 'build/getRooms',
      canShareBuild: 'build/canShareBuild',
    }),
    shareDisabledReason() {
      return this.canShareBuild
        ? null
        : 'Kies eerst een lijn, dan kun je je samenstelling delen';
    },
    showNextButton() {
      return this.currentStep === 1 || this.currentStep === 2;
    },
    canGoToNextStep() {
      if (this.currentStep === 1) {
        return this.rooms.length === 0
          ? this.products.length > 0
          : this.rooms.every((room) => room.products.length > 0);
      }

      if (this.currentStep === 2) {
        return (
          this.rooms.length > 0 &&
          this.rooms.every((room) => room.line !== null)
        );
      }

      return false;
    },
    incompleteRooms() {
      return this.rooms.filter((room) => {
        // We use an 'invisible' room if no rooms are created. Filter this one out.
        if (room.id === null) {
          return false;
        }

        if (this.currentStep === 1) {
          return room.products.length === 0;
        } else if (this.currentStep === 2) {
          return room.line === null;
        }
      });
    },
  },
  methods: {
    ...mapMutations('filters', ['setSelectedBrandId', 'setSelectedColorId']),
    ...mapActions('step', [
      'goToStepBrandColorSelection',
      'goToStepFinishOrder',
    ]),

    onNextStep() {
      if (!this.canGoToNextStep) {
        this.incompleteRooms.forEach((room) => {
          const element = document.querySelector(`.room#room-${room.id}`);
          element.classList.add('pulse');

          setTimeout(() => {
            element.classList.remove('pulse');
          }, 1000);
        });

        return;
      }

      if (this.currentStep === 1) {
        this.goToStepBrandColorSelection();
        this.selectAllRooms();

        return;
      }

      if (this.currentStep === 2) {
        this.goToStepFinishOrder();
      }
    },
    determineScreenSize() {
      this.screenWidth = innerWidth;
    },
    openSharePopup() {
      if (!this.canShareBuild) {
        return;
      }

      this.open = true;
    },
    selectAllRooms() {
      this.$store.commit('brand-color-selection/setAllRoomsSelected', true);
    },
  },
  mounted() {
    window.addEventListener('resize', this.determineScreenSize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.determineScreenSize);
  },
};
</script>
